import { IIncome } from "src/domain/entities"
import { incomeListApi } from "../../api/income/incomeListApi"

type PayloadShape = Parameters<typeof incomeListApi>[0]

export async function incomeListService(payload: PayloadShape, token?: null | string) {
	const income = await incomeListApi(payload, token)
	return income as NonNullable<IIncome[]>
}
